var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var secureMessageAppointmentSimpleViewTemplate = require('./secureMessageAppointmentSimpleViewTemplate.hbs');
var AppointmentTypeParentBehavior = require('./../behaviors/AppointmentTypeParentBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel.js');
var viewUtils = require('./../utils/viewUtils');

/**
 * @class SecureMessageAppointmentSimpleView
 * @constructor
 */
module.exports = TorsoView.extend({
  tagName: 'li',
  className: 'brec-list__item',
  template: secureMessageAppointmentSimpleViewTemplate,

  /**
   * Adds attributes to the the top level element (this is to support existing behavioral tests that query these values).
   * This only works because, as an item view, this view will only be created when the model already exists.  Values will not
   * be updated dynamically if they change for this view after it renders.
   * @returns {{data-test-appointment-external-id: String, data-test-item-appointment: String}} the id and selector for appointment
   */
  attributes: function() {
    return {
      'data-test-appointment-external-id': this.model.get('appointmentDTO.externalAppointment.externalId'),
      'data-test-item-appointment': true
    };
  },

  events: {
    'change [data-select-appointment-checkbox]': '_toggleSelectAppointment'
  },

  behaviors: {
    appointmentTypeParentBehavior: {
      behavior: AppointmentTypeParentBehavior
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: { property: 'model:appointmentDTO.externalAppointment.type'}
    },
    parentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: { property: 'behaviors.appointmentType.data:parentExternalId'}
    },
    grandparentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: { property: 'behaviors.parentAppointmentType.data:parentExternalId'}
    }
  },

  prepareFields: {
    selectable: '_selectable',
    appointmentTimeReplacement: function() {
      var appointmentTypeModel = this.getBehavior('appointmentType').data.getModel();
      return appointmentTypeModel && appointmentTypeModel.getEffectiveAppointmentTimeReplacement();
    },
    removeAppointmentTimeDisplay: function() {
      if (appointmentConfigurationModel.isLoading() || !appointmentConfigurationModel.hasLoadedOnce()) {
        return false;
      }
      return appointmentConfigurationModel.get('removeAppointmentTimeDisplay');
    }
  },

  /**
   * Note this will only work if the view is configured with selectable = true.
   * @return {Boolean} true if this view is selected.  False otherwise.
   */
  isSelected: function() {
    return this.get('selected') || false;
  },

  /**
   * @return {String} the external id of the appointment used to generate this view.
   */
  getAppointmentExternalId: function() {
    return this.model.get('appointmentDTO.externalAppointment.externalId');
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.selectable {Boolean} true if the item should be selectable, false otherwise.  Only used if context.selectable is not set.
   *   @param options.context {Object} the item context that is passed in from the list view.
   *   @param options.context.selectable {Boolean} true if the item should be selectable, false otherwise.  Overrides options.selectable.
   *   @param options.context.className {String} additional class names to use
   * @override
   */
  initialize: function(options) {
    options = options || {};
    var context = options.context || {};
    this._selectable = context.selectable || options.selectable;
    if (!_.isUndefined(context.className)) {
      viewUtils.updateViewClassNameDuringInitialize(this, context.className);
    }
    this.set('selected', context.defaultSelected);

    this.listenTo(this.viewState, 'change:selected', this.render);
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
    appointmentConfigurationModel.loadOnce();
  },

  /**
   * Toggle the value for selected on this view.
   * @method _toggleSelectAppointment
   * @private
   */
  _toggleSelectAppointment: function() {
    var selected = !this.get('selected');
    this.set('selected', selected);
  }
});
